import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import Checkbox from 'components/Inputs/Checkbox/Checkbox';

const DefaultPaymentCheckbox = ({
    paymentName,
    checked,
    disabled,
    setAsDefaultPaymentLabel,
    addDefaultPaymentToProfile,
    removeDefaultPaymentFromProfile,
    onToggle
}) => {
    const handleClick = () => {
        if (checked) {
            removeDefaultPaymentFromProfile(paymentName);
        } else {
            addDefaultPaymentToProfile(paymentName);
        }

        onToggle?.(checked ? 'remove' : 'add');
    };

    return (
        <Checkbox
            paddingY={2}
            checked={checked}
            disabled={disabled}
            onClick={handleClick}
        >
            {setAsDefaultPaymentLabel}
        </Checkbox>
    );
};

DefaultPaymentCheckbox.propTypes = {
    paymentName: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    setAsDefaultPaymentLabel: PropTypes.string.isRequired,
    addDefaultPaymentToProfile: PropTypes.func.isRequired,
    removeDefaultPaymentFromProfile: PropTypes.func.isRequired,
    onToggle: PropTypes.func
};

export default wrapFunctionalComponent(DefaultPaymentCheckbox, 'DefaultPaymentCheckbox');
